import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';

@Component({
  selector: 'df-unique-validator-editor',
  templateUrl: './unique-validator-editor.component.html',
  styleUrls: ['./unique-validator-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UniqueValidatorEditorComponent extends ValidatorEditorBase<any> implements OnInit {
  ngOnInit() {
    if (!this.caption) {
      this.caption = 'å¯ä¸';
    }
  }
  defaultModelData(): any {
    return undefined;
  }
}
